import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

const EventCardSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.3,
          duration: 800,
          useNativeDriver: true,
        }),
      ]),
    ).start();
  }, []);

  return (
    <Animated.View
      style={{ opacity }}
      className="bg-chalk rounded-2xl overflow-hidden md:border md:border-ash-3"
    >
      <View className="px-2 pt-2">
        <View className="h-32 rounded-xl bg-ash-3" />
      </View>
      <View className="px-2 py-2 gap-2 md:py-3 md:gap-3">
        <View className="h-4 w-3/4 rounded-md bg-ash-3" />
        <View className="h-3 w-1/2 rounded-md bg-ash-3" />
        <View className="h-3 w-1/3 rounded-md bg-ash-3" />
      </View>
    </Animated.View>
  );
};

export default EventCardSkeleton;
